import React from "react";

function EmptyState({ title = "내용이 없습니다", description, action }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-white/15 bg-white/5 px-6 py-10 text-center">
      <div className="text-lg font-semibold text-white">{title}</div>
      {description && <p className="text-sm text-ink-200">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export default EmptyState;
